module.exports = __webpack_public_path__ + "img/5.10ed5101.jpg";